module.exports = __webpack_public_path__ + "static/puto-cheese-4ca2a8d7798be1608877b3fd4cbfa6f4.jpg";